import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CalendarCheck, ChevronRight } from "lucide-react";

// Feature 21 — compact entry point into the free Move-Out Day utility.
export function MoveOutDayCard({ propertyId }) {
  const navigate = useNavigate();
  return (
    <div className="rounded-2xl border-2 border-brand/30 bg-gradient-to-br from-brand/[0.06] to-white p-5 sm:p-6" data-testid="moveout-day-card">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="grid place-items-center h-9 w-9 rounded-xl bg-brand/10 text-brand"><CalendarCheck size={18} /></span>
            <h3 className="font-heading text-lg font-semibold text-navy">Move-Out Day</h3>
          </div>
          <p className="mt-2 text-sm text-[#475569]">
            One place to organize evidence sync, final documentation, your return record, and follow-through — with truthful status from your TenantSeal records. Free.
          </p>
        </div>
      </div>
      <Button data-testid="open-moveout-day-btn" onClick={() => navigate(`/move-out-day/${propertyId}`)}
        className="mt-4 h-11 px-5 rounded-xl bg-brand hover:bg-brand-hover text-white font-semibold">
        Open Move-Out Day <ChevronRight size={16} className="ml-1" />
      </Button>
    </div>
  );
}
